import axios from 'axios';
import { API_BASE } from '../../../scripts/utils/api';

const reserveItemForm = document.getElementById('FormReserveInStore');
if (!reserveItemForm) return;

function parseDanishPrice(priceStr) {
  return parseFloat(priceStr.replace(/[^\d,.-]/g, '').replace(/\./g, '').replace(',', '.'));
}

// set value to store email input from store select input
const reserveItemStoreEmailInput = reserveItemForm.querySelector('[name=storeEmail]');
const reserveItemStoreSelect = reserveItemForm.querySelector('[name=store]');
if (reserveItemStoreSelect && reserveItemStoreEmailInput) {
  reserveItemStoreSelect.addEventListener('change', function (ev) {
    reserveItemStoreEmailInput.value = ev.target.selectedOptions[0].getAttribute('email');
  });
}


let grecaptchaToken = null;
let isRecaptchaInitialized = false; // Flag to prevent multiple initializations
let isRecaptchaScriptLoaded = false; // Flag to track if the script is already loaded

function loadRecaptchaScript(callback) {
  if (isRecaptchaScriptLoaded) {
    callback(); // If already loaded, directly initialize
    return;
  }

  // Dynamically set the language for reCAPTCHA
  const currentLocale = window.themeSettings?.current_locale || 'en'; // Fallback to 'en' if locale is not set
  const script = document.createElement('script');
  script.src = `https://www.google.com/recaptcha/api.js?hl=${currentLocale}`;
  script.async = true;
  script.defer = true;
  script.onload = () => {
    isRecaptchaScriptLoaded = true;
    callback();
  };
  script.onerror = () => console.log('Error loading reCAPTCHA script');
  document.head.appendChild(script);
}

function initializeRecaptcha() {
  if (isRecaptchaInitialized) return; // Prevent re-initialization
  isRecaptchaInitialized = true;

  if (window.grecaptcha) {
    grecaptcha.ready(async () => {
      console.log('grecaptcha is ready!');
      await grecaptcha.render('g-recaptcha-placeholder', {
        sitekey: window.themeSettings.recaptchaSiteKey,
        callback: function (response) {
          grecaptchaToken = response;
        },
        'expired-callback': function () {
          grecaptchaToken = null;
          grecaptcha.reset();
        },
        'error-callback': function () {
          grecaptchaToken = null;
        },
      });
    });
  }
}

const drawer = document.querySelector('[data-component-id="reserve-in-store-drawer"]');
drawer.addEventListener('drawer-opened', () => {
  loadRecaptchaScript(initializeRecaptcha);
});

reserveItemForm.addEventListener('submit', async (e) => {
  e.preventDefault();

  const submitButton = reserveItemForm.querySelector('button[type="submit"]');
  submitButton.disabled = true;

  const errorPlaceholder = reserveItemForm.querySelector('[data-error]');
  let captchaLoaded = null,
    captchaError = null;

  if (window.themeSettings.recaptchaSiteKey && window.themeSettings.recaptchaSiteKey.length > 0) {
    captchaLoaded = grecaptcha.getPageId();
    if (captchaLoaded) {
      if (!grecaptchaToken) {
        if (errorPlaceholder && window.translationStrings?.reserveInStore?.captchaError) errorPlaceholder.innerHTML = window.translationStrings.reserveInStore.captchaError;
        captchaError = true;
      }
    }
    if (captchaError) {
      submitButton.disabled = false;
      return;
    }
  }

  await reserveItem();
});

async function reserveItem() {
  const formData = new FormData(reserveItemForm);
  const data = {};
  for (const [key, value] of formData.entries()) {
    data[key] = value;
  }

  if (data['honeypot'] !== '') return;

  // calculate total price based on amount
  const amount = parseInt(data['amount'], 10) || 1;
  if (amount > 1) {
    const priceInput = reserveItemForm.querySelector('input[name="productPrice"]');
    const unitPrice = priceInput.getAttribute('data-selected-price');
    const parsed = parseDanishPrice(unitPrice);
    if (!isNaN(parsed)) {
      const total = (parsed * amount).toFixed(2).replace('.', ',');
      data['productPrice'] = unitPrice.replace(/[\d.,]+/, total);
    }
  }

  const url = `${API_BASE}/reserveItem`;
  const successMessagePlaceholder = reserveItemForm.querySelector('[data-success-message]');
  const errorPlaceholder = reserveItemForm.querySelector('[data-error]');
  const formFieldsContainer = reserveItemForm.querySelector('[data-form-fields]');

  try {
    const response = await axios.put(url, data);
    if (response.status === 200) {
      // Hide form fields and show success message centered
      if (formFieldsContainer) {
        formFieldsContainer.classList.add('hidden');
      }
      if (response?.data?.message && successMessagePlaceholder) {
        successMessagePlaceholder.innerHTML = response.data.message;
        successMessagePlaceholder.classList.remove('hidden');
      }
      if (errorPlaceholder) errorPlaceholder.innerHTML = '';

      reserveItemForm.reset();
      if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
        grecaptcha.reset();
      }
      grecaptchaToken = null;
    }
  } catch (error) {
    console.log('Error: ', error);
    if (errorPlaceholder && window.translationStrings?.reserveInStore?.error) errorPlaceholder.innerHTML = window.translationStrings.reserveInStore.error;
    if (successMessagePlaceholder) successMessagePlaceholder.innerHTML = '';
    // Re-enable button on error so user can retry
    const submitButton = reserveItemForm.querySelector('button[type="submit"]');
    if (submitButton) submitButton.disabled = false;
  }
}

const messageContainer = reserveItemForm.querySelector('[data-success-message]');
const storeSelect = reserveItemForm.querySelector('select[name="store"]');

function pushStorePickupEvent(storeName, price) {
  if (typeof window.dataLayer === 'undefined') {
    window.dataLayer = [];
  }
  window.dataLayer.push({
    'event': 'store_pickup',
    'store_name': storeName,
    'store_price': price
  });
}

let selectedStoreName = '';

if (storeSelect) {
  storeSelect.addEventListener('change', function () {
    selectedStoreName = storeSelect.options[storeSelect.selectedIndex].text.trim();
  });
}

if (messageContainer) {
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList' && isTextContentNotBlank(messageContainer)) {
        let storeNameToPush = selectedStoreName;
        if (!storeNameToPush) {
          storeNameToPush = storeSelect.options[storeSelect.selectedIndex].text.trim();
          console.warn("Store name obtained from MutationObserver (fallback):", storeNameToPush);
        }
        const unitPrice = parseDanishPrice(reserveItemForm.querySelector('input[name="productPrice"]').getAttribute('data-selected-price'));
        const amount = parseInt(reserveItemForm.querySelector('input[name="amount"]')?.value, 10) || 1;
        pushStorePickupEvent(storeNameToPush, unitPrice * amount);
        observer.disconnect();
      }
    });
  });

  observer.observe(messageContainer, { childList: true, subtree: true });
}

function isTextContentNotBlank(element) {
  if (!element) return false;
  return element.textContent.trim().length > 0;
}
